// client/src/utils/media/getOrgMediaPath.js
import { BUCKET_LIST } from '../../constants/server-type';

/**
 * Build a public media URL from a media record
 *
 * Accepts either:
 *  - full media object
 *  - { bucket, key }
 */

 export function getOrgMediaPath(key) {
   if (!key) return '';
   return `https://${BUCKET_LIST}/${key}`;
 }
